import { render, staticRenderFns } from "./SectionOfQuestions8to10.vue?vue&type=template&id=5c314ff0&"
import script from "./SectionOfQuestions8to10.vue?vue&type=script&lang=js&"
export * from "./SectionOfQuestions8to10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports